import { API_URLs } from "../../utilities/API_URLs"
import iAxios from "../../utilities/axios/axios-setup"

export const loadMenuForUser = () => {
  return iAxios.get(API_URLs.menu.getMenus + '?pagination=false&lvl=0&isShow=true&groups[]=menu:list-show&order[position]=asc',)
  .then(r => {
    return r.data;
  })
  .catch(e => {
    return e;
  })
}

export const getAllUserAccess = () => {
  return iAxios.get(API_URLs.menu.getMenus + '?pagination=false&order[position]=asc',)
  .then(r => {
    return r.data;
  })
  .catch(e => {
    return e;
  })
}
